import toast from 'react-hot-toast'

export const formatApiDetail = (detail, fallback = '') => {
  if (detail === null || detail === undefined || detail === '') return fallback
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === 'string') return item
        if (item?.msg) {
          const location = Array.isArray(item.loc) ? item.loc.join('.') : ''
          return location ? `${location}: ${item.msg}` : String(item.msg)
        }
        return null
      })
      .filter(Boolean)
    return messages.join(' ') || fallback
  }
  return fallback
}

export const getApiErrorMessage = (error, fallback = 'Request failed') => {
  const detail = error?.response?.data?.detail
  if (detail) return formatApiDetail(detail, fallback)
  return error?.response?.data?.message || error?.message || fallback
}

export const isNetworkError = (error) => {
  if (!error) return false
  const message = String(error.message ?? '').toLowerCase()
  return (
    (error.name === 'TypeError' && message.includes('fetch')) ||
    message.includes('networkerror') ||
    message.includes('failed to fetch') ||
    message.includes('load failed') ||
    message.includes('network request failed')
  )
}

export const getLeadSignupErrorMessage = ({ status, data, error } = {}) => {
  const detail = formatApiDetail(data?.detail)

  if (status === 400) {
    if (detail) {
      const normalized = detail.replace(/^Domain validation failed:\s*/i, '').trim()
      if (/does not resolve/i.test(normalized)) {
        return 'This email domain could not be verified — it does not appear to be a reachable city website. Use an official city email address and try again.'
      }
      return normalized || detail
    }
    return 'We could not verify this email domain. Use an official city email address and try again.'
  }

  if (status === 422) {
    return detail || 'Enter a valid email address.'
  }

  if (status === 429) {
    return detail || 'Too many signup attempts. Please wait a minute and try again.'
  }

  if (status >= 500) {
    return detail || 'Our signup service is temporarily unavailable. Please try again in a few minutes.'
  }

  if (isNetworkError(error)) {
    return 'Could not reach our signup service. Check your network connection or try again shortly.'
  }

  if (error?.message && !isNetworkError(error)) {
    return error.message
  }

  if (detail) return detail

  if (status) {
    return `Unable to start city email verification (error ${status}). Please try again.`
  }

  return 'Unable to start city email verification. Please try again.'
}

export const toastApiError = (error, fallback = 'Request failed') => {
  toast.error(getApiErrorMessage(error, fallback))
}
